import { SearchRecommendationPill } from "../SearchRecommendationPill";

/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/slate/component/tag)
 */
export const Tags = SearchRecommendationPill;
